import React from 'react'

export default function Loading() {
  return (
    <div class="text-center">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
  )
}
